<template>
  <div class="download">
    <div class="newlogo">
      <img src="static/image/logo.png" alt />
    </div>
    <div class="homeImg">
      <img src="static/image/home.png" alt />
    </div>
    <div class="btn">
      <a href="https://www.pgyer.com/llcOA">
        <van-button type="info">下载联联车</van-button>
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "DownApp",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
  color: #ffffff;
}
.mint-header {
  background-color: rgba(0, 0, 0, 0) !important;
}
.mint-header {
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/downApp.vue